export default __webpack_public_path__ + "static/media/iconSlipperChair.3d9efb13.svg";